module.exports = __webpack_public_path__ + "img/form.9daedcab.svg";